import types from '../actiontypes'

export const ClearAccount = () => {
  return {
    type: types.CurrentSession.ClearAccount
  }
}

export const ClearAccountDispatch = (dispatch) => {
  return () => {
    dispatch(ClearAccount())
  }
}

export const SetAccount = (token, account) => {
  return {
    type: types.CurrentSession.SetAccount,
    payload: {
      token,
      account
    }
  }
}

export const SetAccountDispatch = (dispatch) => {
  return (token, account) => {
    dispatch(SetAccount(token, account))
  }
}

export const UpdateAccount = (data) => {
  return {
    type: types.CurrentSession.UpdateAccount,
    payload: data
  }
}

export const UpdateAccountDispatch = (dispatch) => {
  return (data) => {
    dispatch(UpdateAccount(data))
  }
}

export const ClearSettings = () => {
  return {
    type: types.CurrentSession.ClearSettings,
    payload: {}
  }
}

export const ClearSettingsDispatch = (dispatch) => {
  return () => {
    dispatch(ClearSettings())
  }
}

export const SetSettings = (newSettings, keepExisting = false) => {
  return {
    type: types.CurrentSession.SetSettings,
    payload: {
      newSettings,
      keepExisting: keepExisting
    }
  }
}

export const SetSettingsDispatch = (dispatch) => {
  return (newSettings) => {
    dispatch(SetSettings(newSettings))
  }
}

export const ClearConfig = () => {
  return {
    type: types.CurrentSession.ClearConfig
  }
}

export const ClearConfigDispatch = (dispatch) => {
  return () => {
    dispatch(ClearConfig())
  }
}

export const SetConfig = (config) => {
  return {
    type: types.CurrentSession.SetConfig,
    payload: {
      config
    }
  }
}

export const SetConfigDispatch = (dispatch) => {
  return (config) => {
    dispatch(SetConfig(config))
  }
}

export const ClearGroupSecurity = () => {
  return {
    type: types.CurrentSession.ClearGroupSecurity
  }
}

export const ClearGroupSecurityDispatch = (dispatch) => {
  return () => {
    dispatch(ClearGroupSecurity())
  }
}

export const SetGroupSecurity = (groupSecurity) => {
  return {
    type: types.CurrentSession.SetGroupSecurity,
    payload: {
      groupSecurity
    }
  }
}

export const SetGroupSecurityDispatch = (dispatch) => {
  return (groupSecurity) => {
    dispatch(SetGroupSecurity(groupSecurity))
  }
}
